import { saveAs } from 'file-saver'

export function downloadBlob(blob: Blob, fileName: string) {
  saveAs(blob, fileName)
  return true
}
